import { useEffect } from 'react';

/**
 * Detects clicks outside of specified refs and calls the handler.
 * @param {Object} options
 * @param {Function} options.handler - The function to call when a click outside is detected.
 * @param {Array<React.RefObject>} options.refs - Refs to check for "inside" clicks.
 * @param {Array<React.RefObject>} [options.ignoreRefs] - Optional additional refs to ignore.
 **/

const useClickOutside = ({ handler, refs = [], ignoreRefs = [] }) => {
    useEffect(() => {
        const listener = (event) => {
            const isInsideAnyRef = [...refs, ...ignoreRefs].some((ref) => {
                const el = ref?.current;
                return el?.contains(event?.target);
            });

            if (!isInsideAnyRef) {
                handler(event);
            }
        };

        document.addEventListener('mousedown', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
        };
    }, [handler, refs, ignoreRefs]);
};

export default useClickOutside;
